// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"6d4297f5","239":"4e9b6e14","282":"e1e56b9d","307":"a12836b7","455":"319b09f8","481":"99f51708","593":"733e49ea","814":"99def76e"}[chunkId] + ".chunk.js";
};